import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseClass } from '../../utility/baseClass';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { OrganisationService } from '../../main-layout/organisation/organisation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { OrgtrainingmodalComponent } from '../orgtrainingmodal/orgtrainingmodal.component';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { Contrycodes } from '../../utility/modals';


@Component({
  selector: 'app-organisationmodal',
  templateUrl: './organisationmodal.component.html',
  styleUrls: ['./organisationmodal.component.css']
})
export class OrganisationmodalComponent extends BaseClass implements OnInit {
  @ViewChild('remarksTA') remarksTA!: ElementRef<HTMLTextAreaElement>;
    @ViewChild('stateTA') stateTA!: ElementRef<HTMLTextAreaElement>;


  CSRFToken='';
  form: FormGroup;
  saveTitle="Add";
  isEdit:boolean=false;
  products = [];
  OrganisationForm: FormGroup;
    OrganisationmailForm: FormGroup;

  configdetailsList: Array<any> = [];
  filterproductdata: any = {};
  productlist=[];
  loginuserid=0;
  isOnlyView=false
  statelist=[]
  yesnolist=[
    {label:'Yes',value:'Y'},
    {label:'No',value:'N'}
  ]
   enterpriselist=[
    {label:'Yes',value:'Y'},
    {label:'No',value:'C'}
  ]
    authtypelist=[
    {label:'DB',value:'DB'},
    {label:'AD',value:'AD'}
  ]
  orgtylist=[
    {label:'Self',value:'S'},
    {label:'Practicing firm',value:'P'}
  ];
  orgid:any
  onlyView:boolean=false;
  existingdetails:any;
     first2: number = 0;
  rows2: number = 10;
  totalRecords: number= 0;
  public validation_message = {
    'orgname': [{ type: 'required', message: 'Organisation is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    'address': [
      { type: 'required', message: 'Address is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    'orgtype': [{ type: 'required', message: ' Orgnisation type is Required' }],
    'addressstate':[{ type: 'required', message: 'Address state is required' },
             {type:'maxlength',message:'Maximum length 300 exceeded'}
            ],
    'city':[{type:'required',message:'City is Required'},
       { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    'state':[{type:'required',message:'State Availability is Required'}, 
      {type:'maxlength',message:'Maximum length 1000 exceeded'}],
    'pin':[{type:'required',message:'Pin is required'},
           { type: 'maxlength', message: 'Maximum length exceeded' },
           { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
           { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
    ],
    'country':[{type:'required',message:'Country is required'}],
    'phone':
    [{type:'required',message:'Phone is required'},
      { type: 'maxlength', message: 'Maximum length exceeded.' },
    { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
    { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
    { type:'PHONE_PATTERN' , message:'Mobile Number is invalid.'}
    ],
    'orginitial':[{type:'required',message:'Orginisation initial is required'},
       { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    'noofcompany':[{type:'required',message:'No of entity is required'},
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
    ],
    'noofuser':[{type:'required',message:'No of users is required'},
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
            { type: 'maxlength', message: 'Maximum length exceeded' },
        { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
        { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
    ],
    'nooflocation':[{type:'required',message:'No of location is required'},
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
    ],
        'nooftraining':[{type:'required',message:'No of training is required'},
          { type: 'maxlength', message: 'Maximum length exceeded' },
          { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
          { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
          { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
        ],
    'spaceallowed':[{type:'required',message:'Space allowed is required'},
            { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC', message: 'Only numeric allowed' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
    ],
    'esign':[{type:'required',message:'Enable Esign is required'}],
    'product':[{type:'required',message:'Product is Required'}],
    'dataservice':[{type:'required',message:'Data service is required'}],
    'databackupdownloadflag':[{type:'required',message:'Data Backup is Required'}],
    'issuspended':[{type:'required',message:'Suspended is Required'}],
        'dolive':[{type:'required',message:'Go Live Date is Required'}],
        'requirebusinessuser':[{type:'required',message:'Business user is Required'}],
        'isenterprise':[{type:'required',message:'Is Enterprise is Required'}],
        'authtype':[{type:'required',message:'Authentication type is Required'}],
        'firstname':[{type:'required',message:'First Name is Required'},
          { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
        ],
        'lastname':[{type:'required',message:'Last Name is Required'},
          { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
        ],
        'email':[{type:'required',message:'Email Id is Required'},
          { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end.' },
      { type: 'EMAIL', message: 'Invalid email format' },
      { type: 'maxlength', message: 'Maximum length exceeded.' },
        ]

    

  }
  commonScrollHeight=''
  isemail=false
productids:any;
filevalidation:any;
bdTeam=false;
  constructor(public override injector: Injector,private fb: FormBuilder,private orgservice:OrganisationService, public ref: DynamicDialogRef,
    public utilityservice:Utilityservice,public config: DynamicDialogConfig,private spinnerservice:NgxSpinnerService,private dialogService:DialogService,
   private el: ElementRef,) {

  super(injector);
      this.filevalidation=this.utilityservice.getFilevalidation()

          this.commonScrollHeight=this.utilityservice.updateScrollHeight();
  const datafromparent=this.config.data;
  this.orgid=datafromparent.orgid;
  this.bdTeam = datafromparent.isBdTeam; 
   
  this.gettoken();
  if (datafromparent?.title === 'Modify Organisation' ) {
    this.isEdit = true;
    this.saveTitle = 'Modify';
    this.existingdetails = datafromparent.datas;
    this.formInitial();

    this.dynamicformValidation(this.OrganisationForm,'issuspended',{required:true})
        this.dynamicformValidation(this.OrganisationForm,'databackupdownloadflag',{required:true});
           this.OrganisationForm.get('lastname').clearValidators();
      this.OrganisationForm.get('lastname').updateValueAndValidity();
        // this.dynamicformValidation(this.OrganisationForm,'dolive',{required:true})

    this.patchValue(this.existingdetails);
      this.getattachment(this.orgid)


  }else if (datafromparent?.title === 'View Organisation' ) {
    // this.isEdit = true;
    this.isOnlyView=true;
    this.isemail=false
    this.existingdetails = datafromparent.datas;
    this.formInitial();
    this.patchValue(this.existingdetails);
      this.getattachment(this.orgid)



  }
  else if(datafromparent.title=='Product Wise Email Status'){
   this.isemail=true;
     this.OrganisationmailForm= this.fb.group({ product: [''] })
     
            this.orgservice.getproductemailflaglist(this.orgid).subscribe(res=>{
            this.productlist = res;
           const selectedProducts = res.filter(e => e.emailflag === 'Y');
          this.OrganisationmailForm.patchValue({ product: selectedProducts});
        })
  }
  
 
   const userdata= this.utilityservice.getLoggeduser();
   this.loginuserid=userdata.userid;


  }
  cols=[];
  _selectedColumns=[];
  ngOnInit() {
  if(!this.isemail){  this.getstate();
    this.getcountrylist();
    this.getproducts();
    this.dynamiccols();
    if(!this.isEdit && !this.isOnlyView){
      this.formInitial();
    }}

  }
  ngAfterViewInit() {
  // initial resize (optional)  
  this.resizeTextarea();
}
  resizeTextarea() {
  
  const textarea = this.remarksTA.nativeElement;
  const statetextarea=this.stateTA.nativeElement;

  textarea.style.height = 'auto';
  textarea.style.height = textarea.scrollHeight + 'px';
   statetextarea.style.height = 'auto';
  statetextarea.style.height = statetextarea.scrollHeight + 'px';
}
patchValue(data){
   const golivedate = this.convertToDate(data.golivedate);
     this.patchPhoneNumber(data.phone)
  if(this.isEdit){
        // const golivedate = this.convertToDate(data.golivedate);

  this.OrganisationForm.patchValue({orgname:data.name,
    address:data.address,
    city:data.city,
    country:data.country,
    addressstate:data.state,
    dataservice:data.dataservice,
    pin:data.pin,
    orgtype:data.orgtype,
    spaceallowed:data.spaceallowed,
    orginitial:data.orginitial,
    noofcompany:data.noofcompany,
    nooflocation:data.nooflocation,
    noofuser:data.noofuser,
    nooftraining:data.nooftraining,
    esign:data.esignflag,
    isenterprise:data.enterprise,
    requirebusinessuser:data.requirebusinessusers,
    noofbuser:data.noofbusinessusers,
    authtype:data.authenticationtype,
        issuspended:data.issuspended,
        dolive:golivedate

                  
  })
  }else{
  this.OrganisationForm.patchValue({orgname:data.name,
    address:data.address,
    city:data.city,
    country:data.country,
    addressstate:data.state,
    dataservice:this.yesnovalue(data.dataservice),
    pin:data.pin,
    orgtype:this.orgvalue(data.orgtype),
    spaceallowed:data.spaceallowed,
    orginitial:data.orginitial,
    noofcompany:data.noofcompany,
    nooflocation:data.nooflocation,
    noofuser:data.noofuser,
    nooftraining:data.nooftraining,
    esign:this.yesnovalue(data.esignflag),
    isenterprise:this.yesnovalue(data.enterprise),
    requirebusinessuser:this.yesnovalue(data.requirebusinessusers),
    noofbuser:data.noofbusinessusers,
    authtype:data.authenticationtype,
    issuspended:this.yesnovalue(data.issuspended),
    databackupdownloadflag:this.yesnovalue(data.backupdownloadflag),
      dolive:data.golivedate
            

                  
  })
        setTimeout(() => this.resizeTextarea(),1000);
        // setTimeout(()=>{

        // },1000)

  this.getusercolumns()
  // this.gettrainigtablelist();
}

  this.getadmindetails();
    this.getlicencerelateddata();

}

patchPhoneNumber(fullNumber: string) {
  // Example input: "+9167788776768"
    // Your countryCodes list with label & value
  const found = this.contrycodes.countryCodes.find(code =>
    fullNumber.startsWith(code.value)
  );
console.log(found,"found");

  if (found) {
    const countryCode = found.value; // E.g. '+91'
    const localNumber = fullNumber.slice(countryCode.length); // Rest of number
console.log(countryCode,"contry code");
console.log(localNumber,"local number");


    this.OrganisationForm.patchValue({
      countryCode: countryCode,
      phone: localNumber
    });

  } else{
    this.OrganisationForm.patchValue({
      countryCode: '+91',
      mobile: fullNumber
    });
  }
}

  get formArr(): FormArray  {
    return this.OrganisationForm.get("Rows") as FormArray;
  }


  deleteRow(index: number) {
    
    this.formArr.removeAt(index);
    if (index > -1 && this.configdetailsList.length > 1) { // only splice array when item is found
      this.configdetailsList.splice(index, 1); // 2nd parameter means remove one item only
    }
  }


exceldownloadModal=false
  
  formInitial(){
  this.OrganisationForm= this.fb.group({
    orgname:['',Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
                Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
    address: ['',Validators.compose([
        Validators.required,
        Validators.maxLength(500),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
                Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
    city:['',Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
                Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
    addressstate:['',Validators.required],
    country: ['',Validators.required],
    pin: ['',Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
                Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
      ])],
    phone: ['',Validators.compose([
        Validators.maxLength(15),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
                Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
                Validators.pattern(VALIDATION_PATTERNS.PHONE_PATTERN)
      ])],
    orginitial: ['',Validators.compose([
        Validators.required,
        Validators.maxLength(30),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
                Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
    orgtype: ['',Validators.required],
    noofcompany: ['',Validators.compose([Validators.required, Validators.maxLength(6),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
    noofuser: ['',Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
    nooflocation: ['',Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
    product: ['',Validators.required],
    dataservice:['Y',Validators.required],
    state:['',Validators.required],
    isenterprise:['C',Validators.required],
    requirebusinessuser:['N',Validators.required],
    authtype:['DB',Validators.required],
    email:['',Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.EMAIL)
      ])],
    firstname:['',Validators.compose([
        Validators.required,
        Validators.maxLength(500),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
    lastname:['',Validators.compose([
        Validators.required,
        Validators.maxLength(500),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
                Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
    spaceallowed:['',Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
    nooftraining:['',Validators.compose([Validators.required, Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR), Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
    esign:['',Validators.required],
    file:['',],
    noofbuser:['',Validators.compose([ Validators.maxLength(5),Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC), Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)])],
    issuspended:[''],
    dolive:[''],
    databackupdownloadflag:['Y'],
    licenseChange:['Y'],
    countryCode:['+91']

    })
  }
  filedsname=[]
  contrycodes: Contrycodes=new Contrycodes()
dynamiccols(){
  this.cols=[
   {field:'newentity',header:'Entity Count (New)',type:'text',sort: true , filter:true, width:'2px !important',isChecked:true, class:'otherheader'},
   {field:'previousentity',header:'Entity Count (Old)',type:'Number',sort: true , filter:true, width:'2px !important',isChecked:true, class:'headerid'},
    
    { field: "newusers", header: "User Count (New)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "previoususers", header: "User Count (Old)",type:'Date',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
  
    { field: "newlocations", header: "Location Count (New)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "previouslocations", header: "Location Count (Old)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    
    { field: "newspace", header: "Space in GB (New)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "previousspace", header: "Space in GB (Old)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
   
    { field: "newtraining", header: "Training Count (New)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "previoustraining", header: "Training Count (Old)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
  
    { field: "newbduser", header: "BD User Count (New)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "previousbduser", header: "BD User Count (Old)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
  
    { field: "newissuspended", header: "Is Suspend (New)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "previousissuspended", header: "Is Suspend (Old)",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
   
    { field: "updatedby", header: "Updated By",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "updatedon", header: "Updated On",type:'Date',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
  ]

  // this.cols=[
  //  {field:'updatedOn',header:'Updated On',type:'Date',sort: true , filter:true, width:'2px !important',isChecked:true, class:'otherheader'},
  //    {field:'updatedBy',header:'Updated By',type:'text',sort: true , filter:true, width:'2px !important',isChecked:true, class:'headerid'},
  //   { field: "columnName", header: "Column Name",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
  //   { field: "oldValue", header: "Old Value",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
  //   { field: "newValue", header: "New Value",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } 
  // ]
  this.filedsname = this.cols.map(col => col.field);
 this._selectedColumns = this.cols;
}

  removeSubKey(index: number) {
    if (this.formArr.length > 1) {
      this.formArr.removeAt(index);
    }
  }

  save(){   
     const mobileValue = this.OrganisationForm.value.phone 
  ? this.OrganisationForm.value.countryCode + this.OrganisationForm.value.phone 
  : ''; 
    if(this.OrganisationForm.invalid){
        Swal.fire('Please fill up/Validate all the mandatory/required fields and then Save!', '', 'warning').then(() => {
        this.validateAllFormFields(this.OrganisationForm, this.el); //{7}

      })
    }else{
    Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`
        }).then((value) => {
          if (value.isConfirmed) {
          

  let data={
     'orgname':this.OrganisationForm.value.orgname,
    "address":this.OrganisationForm.value.address,
    "city":this.OrganisationForm.value.city,
    "addressstate":this.OrganisationForm.value.addressstate,
    "country":this.OrganisationForm.value.country,
    "pin":this.OrganisationForm.value.pin,
    "phone":mobileValue,
    "orginitial":this.OrganisationForm.value.orginitial,
    "orgtype":this.OrganisationForm.value.orgtype,
    "noofcompany":this.OrganisationForm.value.noofcompany,
    "noofuser":this.OrganisationForm.value.noofuser,
    "nooflocation":this.OrganisationForm.value.nooflocation,
    "product":this.OrganisationForm.value.product.map(e=>e.productid),
    "dataservice":this.OrganisationForm.value.dataservice,
    "state":this.OrganisationForm.value.state.map(e=>e.stateid),
    "isenterprise":this.OrganisationForm.value.isenterprise,
    "requirebusinessuser":this.OrganisationForm.value.requirebusinessuser,
    "authtype":this.OrganisationForm.value.authtype,
    "email":this.OrganisationForm.value.email,
    "firstname":this.OrganisationForm.value.firstname,
    "lastname":this.OrganisationForm.value.lastname,
    "spaceallowed":this.OrganisationForm.value.spaceallowed,
    "nooftraining":this.OrganisationForm.value.nooftraining,
    "esign":this.OrganisationForm.value.esign,
    "noofbuser":this.OrganisationForm.value.noofbuser,
    "prev_noofcompany":this.existingdetails?.noofcompany,
    "prev_noofuser":this.existingdetails?.noofuser,
    "prev_nooflocation":this.existingdetails?.nooflocation,
    "prev_spaceallowed":this.existingdetails?.spaceallowed,
    "prev_nooftraining":this.existingdetails?.nooftraining,
    "issuspended":this.OrganisationForm.value.issuspended,
    "prev_issuspended":this.existingdetails?.issuspended,
    "prev_noofbuser":this.existingdetails?.noofbusinessusers,
    // "previous_bdusers":this.OrganisationForm.value.noofbusinessusers,


    "csrftoken":this.CSRFToken,
   }
            if(this.isEdit){
              data['id']=this.orgid
              data['dolive']=this.formatDate(this.OrganisationForm.value.dolive);
                data["issuspended"]=this.OrganisationForm.value.issuspended,
          data["databackupdownloadflag"]=this.OrganisationForm.value.databackupdownloadflag,
           data["licenseChange"]=this.OrganisationForm.value.licenseChange,
             
                  this.spinnerservice.show();
            this.orgservice.modifyorg(data).subscribe((data) => {
                  this.spinnerservice.hide()
              Swal.fire("Organisation is modified successfully!", "", "success").then(() => {
                if(this.selectedFiles.length>0)
             {   const dataresp=data.organisation.split(',')                
                this.fileuploadsave(dataresp[0],dataresp[1])
              }
                this.ref.close('Save');
              });
            }, error => {
                  this.spinnerservice.hide();
                if (error.error.response == 'html') {
                      Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                      })
                    }       
              else{ 
              Swal.fire({
                icon: "error",
                text: error.error.error,
                footer: "error status is :" + ' ' + error.status
              });}

            });
            }
          else{ 
                this.spinnerservice.show();    
            this.orgservice.saveorg(data).subscribe((data) => {
                  this.spinnerservice.hide()
              if(data.response=='success'){
                 if(data.organisation=='userexist'){
               Swal.fire({
                icon: "error",
                title: "User already exist",
              });
            }
            else if(data.organisation=='orgexist'){
         Swal.fire({
                icon: "error",
                title: "Organisation already exist",
                text: 'Organisation already exist'
              });
            }
             else {Swal.fire("Organisation is added successfully!", "", "success").then((res) => {
                  const dataresp=data.organisation.split(',')
                     if(this.selectedFiles.length>0)
             {   const dataresp=data.organisation.split(',')                
                this.fileuploadsave(dataresp[0],dataresp[1])
              }

                this.ref.close('Save');
              });}
            }
            }, error => {
                  this.spinnerservice.hide();
                if (error.error.response == 'html') {
                      Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                      })
                    }       
              else{ 
              Swal.fire({
                icon: "error",
                title: error.error.error
              });}
            });
          }
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
                        this.ref.close()

          }
        });      
    }  
  }
 
  gettoken(){
    this.CSRFToken='';
     this.utilityservice.getCSRFtoken().subscribe(res=>{
     this.CSRFToken=res.csrf;
    },error=>{
      Swal.fire(error.error.message,'','error');
    });
  }
  stateview=""
    getstate(){
      this.orgservice.getstatelist().subscribe(res=>{
        this.statelist=res
        if(this.isEdit || this.isOnlyView){
             this.orgservice.getselectedstatelist(this.orgid).subscribe(res=>{
              if(this.isOnlyView){
                const data = res.map(e=>e.stateid);
               const states = data.map(id => this.statelist.find(item => item.stateid === id));        
         
                 this.stateview=states.map(e=>e.statename).join(', ');
              }
            else{ 
              const data = res.map(e=>e.stateid);
            const states = data.map(id => this.statelist.find(item => item.stateid === id));
            this.OrganisationForm.patchValue({ 'state': states });
          }
      })
        }
      })
     }
     getselectedstate(orgid){
      this.orgservice.getselectedstatelist(orgid).subscribe(res=>{
        this.statelist=res;
        this.OrganisationForm.patchValue({state:res})

      })
     }
     contrylist=[]
  getcountrylist(){
    this.orgservice.getcountrylist().subscribe(res=>{
      this.contrylist=res
    })
  }
  productsview=''
  getproducts(){
    this.orgservice.getproductlist().subscribe(res=>{
      this.productlist=res;
      if(this.isEdit || this.isOnlyView){
        this.orgservice.getOrganisationProductlist(this.orgid).subscribe(response => {
            const selectedIds = response.map(e => e.productid);
            if(this.isEdit){
            const selectedproducts = selectedIds.map(id => this.productlist.find(p => String(p.productid) === String(id))).filter(Boolean);
            this.OrganisationForm.patchValue({ product: selectedproducts });
            } else{          
                     const  selectedproducts = selectedIds.map(id => this.productlist.find(p => String(p.productid) === String(id))).filter(Boolean);
                    //  let name=  selectedproducts.map(e=>e.productname).toString();
                     let name = selectedproducts.map(e => e.productname).join(', '); 
                     this.productsview=name;
                 }      
            
        })

      }else{
          const activeProducts = res.filter(e => e.activeflag === 'Y');
          const matchedProducts = activeProducts.map(p =>
          this.productlist.find(item => item.productid === p.productid)).filter(Boolean);
          this.OrganisationForm.patchValue({ product: matchedProducts });
      }
    })
  }
  getadmindetails(){
    this.orgservice.getadmindetailsbyorgid(this.orgid).subscribe(res=>{
      this.OrganisationForm.patchValue({firstname:res[0].firstname});
       this.OrganisationForm.patchValue({lastname:res[0].lastname});
       this.OrganisationForm.patchValue({email:res[0].emailaddr})
    })
  }
  yesnovalue(value){
   let returnval='No'
    if(value=='Y'){
      returnval= 'Yes'
    }
    else{
      returnval= 'No'}
        return returnval

  }
  orgvalue(value){
   let returnval=''
    if(value=='S'){
      returnval= 'Self'
    }
    
    else{
      returnval= 'Practicing firm'}
        return returnval

  }
  fileArray=[]
  selectedFiles: File[] = [];
 onFileSelectedpre(event: any) {
    for (let i = 0; i < event.target.files.length; i++) {
      const fileList = event.target.files[i];
      const file: File = fileList;
      this.selectedFiles.push(file);
      const filedata = {
        filesize: 37746,
        id: 238145,
        originalfilename: file.name
      }
      this.fileArray.push(filedata)
    }
    console.log(this.selectedFiles,"Selected files");
    
  }
 onFileSelected(event: Event) {

  const input = event.target as HTMLInputElement;

  this.selectedFiles = [];
  this.fileArray = [];

  if (!input.files || input.files.length === 0) {
    input.value = '';
    return;
  }

  // 🔴 Extra safety — prevent multiple selection
  if (input.files.length > 1) {
    Swal.fire('Only one file is allowed.', '', 'warning');
    input.value = '';
    return;
  }

  const file = input.files[0];

  const maxFileSize = this.filevalidation.maxfilesize;
  const filenotallowarray = this.filevalidation.filenotallow;

  const fileExtension = file.name
    .substring(file.name.lastIndexOf('.'))
    .toLowerCase();

  // 🔒 Extension check
  if (filenotallowarray.includes(fileExtension)) {
    Swal.fire(
      `As per our Security policy, it is not permitted to upload files with extensions ${filenotallowarray.join(', ')}`,
      '',
      'error'
    );
    input.value = '';
    return;
  }

  // 🔒 Size check
  if (file.size > maxFileSize) {
    Swal.fire(
      `File size exceeded the maximum allowed size.`,
      '',
      'error'
    );
    input.value = '';
    return;
  }

  // ✅ Valid file
  this.selectedFiles.push(file);

  this.fileArray.push({
    filesize: file.size,
    id: new Date().getTime(),
    originalfilename: file.name
  });

}


   fileuploadsave(id,orginitial) {
    // file,@RequestParam String orgid,@RequestParam String orginitial
    const formData = new FormData();
    for (let i = 0; i < this.selectedFiles.length; i++) {
      formData.append("file", this.selectedFiles[i]);
    }
    formData.append('orgid', id);
    formData.append('orginitial', orginitial);
    this.spinnerservice.show()
    this.orgservice.logoUpload(formData).subscribe(res => {
      this.spinnerservice.hide();

    },error=>{
      this.spinnerservice.hide();
      Swal.fire(error.error.message,'','error');
    })
  }
filename=''
  getattachment(orgid){
    this.orgservice.getorgfiledetailsbyorgid(orgid).subscribe(res=>{
      console.log(res[0].logourl);
      let url=res[0].logourl
      if( url!==null && url!==undefined){
     this.filename=res[0].logourl.split('/')[1]
    }
    })
  }

  download(data) {
    // audit/generic/downloadattachment/
    this.spinnerservice.show();
    this.utilityservice.downloadattachmentfile('audit/generic/downloadattachment/'+data.id).subscribe((res) => {
      this.spinnerservice.hide();
      const blob = new Blob([res], { type: res.type });
      saveAs(blob, data.originalfilename);
    }, error => {
      this.spinnerservice.hide();
      Swal.fire(error.error.message,'','error')
    })

  }
  trainiglist=[];
  visible=false;

  gettrainigtablelist(){

   this.ref = this.dialogService.open(OrgtrainingmodalComponent, { header: 'Trainings',
          width: '70vw',
          height:'auto',
        data:{title:'Trainings',orgid:this.orgid},
        contentStyle: { overflow: ''  },
        baseZIndex: 10000,
        maximizable: true,
      });

}
numberColumns=[]
getusercolumns(){
  this.orgservice.getcomlocusernumberabyorgid(this.orgid).subscribe(res=>{
   this.numberColumns=[
    {
      boldtr:'Max. Allowed',
      company:res[0].noofcompany,
      location:res[0].nooflocation,
      user:res[0].noofuser,
      traning:res[0].nooftraining,
      storeg:res[0].spaceallowed,
      bdusers:res[0].noofbusinessusers,
      class:''
    },{
       boldtr:'Actual Used',
      company:res[0].usedcompany,
      location:res[0].usedlocation,
      user:res[0].usedusers,
      traning:res[0].usedtrainings,
      storeg:res[0].usedspace,
      bdusers:res[0].usedbdusers,
      class:'color-red'
    }
   ]
  })
}
trainingtable(){
  console.log("get traning");
  this.gettrainigtablelist();
  
}

tableData=[];
options=[];
paginatorArray=[];
getlicencerelateddata(){
  this.orgservice.gettablelicensedatabyorgid(this.orgid).subscribe(res=>{
    this.tableData=res;
    this.tableData.map(e=>{
      if(e.newissuspended=='Y'){
        e.newissuspended='Yes'
      }else{
       e.newissuspended='No'

      }
          if(e.previousissuspended=='Y'){
        e.previousissuspended='Yes'
      }else{
       e.previousissuspended='No'

      }
    })
    this.totalRecords=res.length;
      this.options=  this.utilityservice.getOptionDropdown(res.length);
        this.paginatorArray=this.options.map(e=>e.value);
  })
}
handlePageChange(event: any) {
  this.rows2=event.rows
}
downloadexcel(){
  this.spinnerservice.show()
  this.orgservice.downloadExcelData('organisation/getlicenseexcel','get',this.orgid).subscribe((response: Blob) => {
      const blob = new Blob([response],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Related-Data-Changes.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.spinnerservice.hide();
      Swal.fire('File Downloaded Successfully!', '', 'success');
    }, error => {
      this.spinnerservice.hide();
      Swal.fire(error.error.message, '', 'error');

    });
}

savemail(){
  // let products=this.OrganisationmailForm.value.map(e=>e.productid);
  let products = this.OrganisationmailForm.value.product;

let payloadProducts = products && products.length > 0
    ? products.map(e=>e.productid)
    : '';
  const payload={id:this.orgid,product:payloadProducts}
  this.orgservice.modifyproductemailflag(payload).subscribe(res=>{
       Swal.fire("Email Status modified successfully!", "", "success").then(() => {
                this.ref.close();
              });

  })
}

 getdepTooltip(values:any[]): string {
   if (!values?.length) return `Select Department`;

  const names = values.map(v => v.departmentname);

  return names.join(', ');
  }
   getStatesavailbleTooltip(values:any[]): string {
   if (!values?.length) return `Select State Availability`;

  const names = values.map(v => v.statename);

  return names.join(', ');
  }
  getProductTooltip(values:any[]): string {
   if (!values?.length) return `Select Modules Products`;

  const names = values.map(v => v.productname);

  return names.join(', ');
  }



}


